module.exports = __webpack_public_path__ + "img/kis_vw2.acefe881.jpg";